import i18n from '../i18n';

export const IS_OFFLINE_MODE = false;
export const IS_UI_MODE = false;
export const IS_TMP_MODE = false;


// export const SERVER_URL = IS_OFFLINE_MODE ? 'http://175.126.176.106' : 'http://made.supersoft.kr';
export const SERVER_URL = IS_OFFLINE_MODE ? 'http://175.126.176.106' : 'https://app.madepf.com';
const util = require('util');

export const ADMIN_TAB = {
  MEMBER: 0,
  PENDING_MEMBER: 1,
  POINT: 2,
  POINT_SETTING: 3,
  WRITE: 4,
  VIEW_MEMBER: 5,
  ADS: 6,
  SALE_REQ: 7,
  SALE_LOG: 8,
  LOGIN_MEMBER: 10,
  ADMIN: 11,
};

const Constant = {
  API_URL: SERVER_URL + '/api/v1/',
  IMAGE_FOO_URL: 'http://app.madepf.com/ic_no_pic.png',
  DATAGO_SERVICE_KEY: 'Ksma9qDDkKIM0Er01lkN0yxENEsoQ2WAIxJrZ+O8/vjTrUzRsxeSBGrDDJmtBHnx1L7b0ATCAUQmLziUxLgHBg==',
  //VWORD_SERVICE_KEY: '6F6E905B-925A-3B90-9744-4F15D8414368',
  VWORD_SERVICE_KEY: 'BCC23A85-FA6B-396A-AADE-115215F2C9F9', // 20241210 새로 발급받음

  PAGE_COUNT: 50,
  MAX_FLOOR_CNT: 30,
  MAX_ROOM_CNT: 10,
  MAX_TOILET_CNT: 10,
  MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY: 4,
  MAX_UTILITY_ROOM_CNT: 10,
  MAX_VERANDA_CNT: 10,
  MAX_HOUSE_PER_FLOOR_CNT: 300,

  EVENT_PARAMS: {
    AGREE_TERMS: 'agree_terms',
  },

  PREF_PARAMS: {
    PHONE: 'phone_num',
    CODE: 'auth_code',
    TEMP_STEP: 'temp_step',
    TICKET_SHOW: 'ticket_show',
    TICKET_PRICE: 'ticket_price'
  },
  Color:{
    $primary: '#257fff',
    $logo: '#267fff',
    $accent: '#5f64f7',
    $white: '#ffffff',
    $black: '#000000',
    $text: '#010101',
    $dim_bg: 'rgba(0, 0, 0, .6)',
    $yellow_bg: 'rgba(255,192,0, 1)',
    $c_b5b5b5: '#b5b5b5',
    $c_525251: '#525251',
    $c_4e4e4e: '#4e4e4e',
    $c_f6f4f4: '#f6f4f4',
    $c_cacbcd: '#cacbcd',
    $c_6c6969: '#6c6969',
    $c_457fff: '#457fff',
    $c_acacac: '#acacac',
    $c_a6a6a6: '#a6a6a6',
    $c_a3a3a3: '#a3a3a3',
    $red: '#cf0000',
    $trading1: '#cf0000',
    $trading: '#D99694',
    $charter: '#558ED5',
    $charter1: '#0840ba',
    $invest: '#FAC090',
    $invest1: '#ff7f00',
    $dongsi: '#6408ba',
    $monthly: '#C3D69B',
    $monthly1: '#086e16',
    $c_f7f7f8: '#f7f7f8',
    $c_727373: '#727373',
  },
  MAIN_TAB: {
    HOME: 0,
    INTEREST: 1,
    MAP: 2,
    COMMUNITY: 3,
    MORE: 4,
    ADMIN: 5,
    NOTIFY: 6,
    SALE: 7,
  },

  NOTIFY_TAB: {
    SEND: 1,
    MODIFY: 2,
    AUTO: 3,
  },

  ADMIN: {
    TAB:{
      MEMBER: 0,
      ACCEPT: 1,
      POINT: 2,
      PERIOD: 3,
      WRITE: 4,
      INFO: 5,
      ADS: 6,
      LOGIN: 7,
      SALE: 8,
      CONFIRM: 9,
      MANAGE: 10,
      SITE: 11,
    },
    AD:{


    },
    SCH_FORM:{
      f_title:i18n.t('community.title'),
      f_content:i18n.t('community.content'),
      f_title_content:i18n.t('community.title_content'),
      f_site_name:i18n.t('community.site'),
      f_contact:i18n.t('community.phone'),
    }
  },

  MAEMUL_TYPE: {
    TRADING: 0,
    CHARTER: 1,
    INVEST: 2,
    MONTHLY: 3,
  },

  API_RES_CODE: {
    SUCCESS: 0,
    ERR_API: -1,
    TOKEN_EMPTY: -2,
    TOKEN_EXPIRED: -3,
    ERR_PARAM: -4,
    ERR_OTHER_DEVICE_LOGIN: -7,
    RESULT_CERT_ANSWER: -8,
    RESULT_STATUS_CHANGED_LOGIN: -9,
    RESULT_ALREADY_EXIST: -11,
    RESULT_MEMBER_NOT_EXIST_IN_GROUP: -12,
  },

  COMMUNITY_TYPE: {
    NOTICE: 'N',
    SITE: 'S',
    WORKER_JOB: 'W',
    REPORT: 'R',
    ALL: null,
  },

  ADS_VIEW_MODE: {
    SEQUENCE: 'S',
    RANDOM: 'R',
  },

  SITE_STATUS: {
    NORMAL: 'N',
    PENDING: 'P',
    DROP_OFF: 'D'
  },

  UNIT: {
    square_meter: '㎡',
  },

  COMMUNITY_CATEGORY: {
    'N': i18n.t('community.notice'),
    'S': i18n.t('community.find_site'),
    'W': i18n.t('community.worker_job'),
    'R': i18n.t('community.report1'),
  },

  COMMUNITY_CATEGORY1: {
    'N': i18n.t('community.notice'),
    'S': i18n.t('community.find_site'),
    'W': i18n.t('community.worker_job'),
    'R': i18n.t('community.report'),
  },

  INQUIRE_CATEGORY: {
    'R': i18n.t('inquire.sale_register'),
    'U': i18n.t('inquire.usage'),
    'A': i18n.t('inquire.ads'),
    'C': i18n.t('inquire.community'),
    'N': i18n.t('inquire.news'),
    'P': i18n.t('inquire.point'),
    'O': i18n.t('inquire.other'),
  },

  INQUIRE_TYPE: {
    REGISTER: 'R',
    USAGE: 'U',
    ADS: 'A',
    COMMUNITY: 'C',
    NEW: 'N',
    POINT: 'P',
    OTHER: 'O',
  },

  INQUIRE_FORM:{
    f_title:i18n.t('community.title'),
    f_content:i18n.t('community.content'),
    f_title_content:i18n.t('community.title_content'),
    f_user_name:i18n.t('admin_view_member.name'),
    f_type:i18n.t('site_detail.type'),
  },

  INQUIRE_CATEGORY1: {
    'R': i18n.t('inquire.sale_register'),
    'U': i18n.t('inquire.usage'),
    'A': i18n.t('inquire.ads'),
    'C': i18n.t('inquire.community'),
    'N': i18n.t('inquire.news'),
    'P': i18n.t('inquire.point1'),
    'O': i18n.t('inquire.other'),
  },
  MF_CATEGORY: {
    // [i18n.t('map.all')]: '',
    [i18n.t('map.new_open_site')]: 'O',
    [i18n.t('map.general_site')]: 'G',
  },
  MF_ROOM_NUM: {
    [i18n.t('map.all')]: '',
    [i18n.t('map.one_room')]: '0',
    [i18n.t('map.one_half_room')]: '1',
    [i18n.t('map.two_room')]: '2',
    [i18n.t('map.three_room')]: '3',
    [i18n.t('map.four_room_more')]: '4',
  },
  MF_ROOM_NUM1: {
    [i18n.t('map.one_room')]: '0',
    [i18n.t('map.one_half_room')]: '1',
    [i18n.t('map.two_room')]: '2',
    [i18n.t('map.three_room')]: '3',
    [i18n.t('map.four_room_more')]: '4',
  },
  ORDER_TYPE: {
    [i18n.t('common.order_asc')]: 'ASC',
    [i18n.t('common.order_desc')]: 'DESC',
  },
  ROOM_NUM: [
    i18n.t('map.all'),
    i18n.t('map.one_room'),
    i18n.t('map.one_half_room'),
    i18n.t('map.two_room'),
    i18n.t('map.three_room'),
    i18n.t('map.four_room_more'),
  ],
  ROOM_NUM_SELECT: [
    '',
    i18n.t('map.one_room'),
    i18n.t('map.one_half_room'),
    i18n.t('map.two_room'),
    i18n.t('map.three_room'),
    i18n.t('map.four_room'),
    // i18n.t('map.four_room_more'),
  ],
  ROOM_NUM_SELECT1: [
    '',
    i18n.t('map.one_room'),
    i18n.t('map.one_half_room'),
    i18n.t('map.two_room'),
    i18n.t('map.three_room'),
    i18n.t('map.four_room_more'),
  ],
  MF_TOILET: {
    [i18n.t('map.one_toilet')]: '1',
    [i18n.t('map.two_toilet')]: '2',
    [i18n.t('map.three_toilet1')]: '3',
  },
  MF_TOILET1: {
    [i18n.t('map.one_toilet')]: '1',
    [i18n.t('map.two_toilet')]: '2',
    [i18n.t('map.three_toilet')]: '3',
  },
  VERANDA_UTILITY_NUM: {
    [i18n.t('map.none')]: '0',
    [i18n.t('map.one_toilet')]: '1',
    [i18n.t('map.two_toilet')]: '2',
  },
  MF_ELEVATOR: {
    [i18n.t('map.all')]: '',
    [i18n.t('map.exist')]: 'Y',
    [i18n.t('map.none')]: 'N',
  },
  TRANS_TYPE: {
    [i18n.t('map.all')]: '',
    [i18n.t('interest.trading')]: 'T',
    [i18n.t('interest.charter')]: 'C',
    [i18n.t('interest.invest')]: 'I',
    [i18n.t('interest.monthly')]: 'M',
  },
  TRANS_TYPE_MAP: {
    [i18n.t('map.all')]: '',
    [i18n.t('room_info_popup.sale_price')]: 'T',
    [i18n.t('interest.charter')]: 'C',
    [i18n.t('interest.invest')]: 'I',
    [i18n.t('interest.monthly')]: 'M',
  },
  TRANS_TYPE_MAP1: {
    [i18n.t('room_info_popup.parcel_price1')]: 'T',
    [i18n.t('interest.charter')]: 'C',
    [i18n.t('interest.monthly')]: 'M',
    [i18n.t('interest.invest')]: 'I',
  },
  MAEMUL_TYPE_MAP: {
    '0': i18n.t('maemul_type')[0],
    '3': i18n.t('maemul_type')[1],
    '1': i18n.t('maemul_type')[2],
    '2': i18n.t('maemul_type')[3],
    '6': i18n.t('maemul_type')[4],
    '4': i18n.t('maemul_type')[5],
    '5': i18n.t('maemul_type')[6],
  },
  MAEMUL_TYPE_MAP_REVERSE: {
    [i18n.t('maemul_type')[0]]: '0' ,
    [i18n.t('maemul_type')[1]]: '3' ,
    [i18n.t('maemul_type')[2]]: '1' ,
    [i18n.t('maemul_type')[3]]: '2' ,
    [i18n.t('maemul_type')[4]]: '6' ,
    [i18n.t('maemul_type')[5]]: '4' ,
    [i18n.t('maemul_type')[6]]: '5' ,
  },
  MF_AREA: {
    [i18n.t('map.all')]: '',
    [i18n.t('map.exclusive_area')]: 'E',
    [i18n.t('map.real_area')]: 'R',
  },
  FEE1: {
    [i18n.t('map.all')]: '',
    [i18n.t('interest.trading')]: 'T',
    [i18n.t('interest.charter')]: 'C',
    [i18n.t('interest.invest')]: 'I',
    [i18n.t('map.court')]: 'O',
    [i18n.t('map.site_check')]: 'S',
  },
  FEE_KEY : ['T', 'C', 'I', 'M'],
  FEE_TYPES : {
    TRADING: 'T',
    CHARTER: 'C',
    MONTHLY: 'M',
    INVESTMENT: 'I',
    SITE_INQUIRE: 'S',
  },
  COPY_OPTIONS: {
    [i18n.t('register.all_info')]: 'A',
    [i18n.t('register.only_photo')]: 'P',
  },
  MF_FEE: {
    [i18n.t('map.all')]: '',
    [i18n.t('interest.trading1')]: 'T',
    [i18n.t('interest.charter')]: 'C',
    [i18n.t('interest.invest')]: 'I',
    [i18n.t('map.court')]: 'O',
    [i18n.t('map.site_check')]: 'S',
  },
  FEE2: {
    [i18n.t('register.r_residence')]: 'T',
    [i18n.t('interest.charter')]: 'C',
    [i18n.t('interest.monthly')]: 'M',
    [i18n.t('interest.invest')]: 'I',
    [i18n.t('map.site_check')]: 'S',
  },
  PERIOD: {
    [i18n.t('map.all')]: '',
    [i18n.t('map.regist_date')]: 'R',
    [i18n.t('map.open_date')]: 'O',
  },
  FEE_CHARTER_TYPE: [
    i18n.t('register.single_hit'),
    i18n.t('register.double_hit'),
    i18n.t('register.none_hit'),
  ],
  OPEN_DATE: {
    [i18n.t('map.all')]: -1,
    [util.format(i18n.t('map.m1'), 1)]: 1,
    [util.format(i18n.t('map.m1'), 3)]: 3,
    [util.format(i18n.t('map.m1'), 6)]: 6,
    [util.format(i18n.t('map.y'), 1)]: 12,
    [i18n.t('map.select_period')]: 0,
  },
  API: {
    Auth: {
      getAppInfo: 'auth/getAppInfo',
      signUp: 'auth/signUp',
      login: 'auth/login',
      adminLogin: 'auth/adminLogin',
      authPhone: 'auth/authPhone',
      checkPhoneAuthCode: 'auth/checkPhoneAuthCode',
      getCertQuestionList: 'auth/getCertQuestionList',
      updateCertAnswer: 'auth/updateCertAnswer',
    },
    Upload: {
      image: 'upload/image',
    },
    User: {
      getProfile: 'user/getProfile',
      regUserAnswer: 'user/regUserAnswer',
      getHomeData: 'user/getHomeData',
      updatePushSetting: 'user/updatePushSetting',
      updateProfile: 'user/updateProfile',
      addPhoneNumber: 'user/addPhoneNumber',
      removeUserFromDB: 'user/removeUserFromDB',
      changeUserStatus: 'user/changeUserStatus',
      getPendingUserList: 'user/getPendingUserList',
      findUserByPhone: 'user/findUserByPhone',
      getUserDetail: 'user/getUserDetail',
      changeUserStatusById: 'user/changeUserStatusById',
      exitApp: 'user/exitApp',
      logout: 'user/logoutPC'
    },
    Group: {
      getAllGroup: 'group/getAllGroup',
      shareSiteToGroup: 'group/shareSiteToGroup',
      releaseSiteFromGroup: 'group/releaseSiteFromGroup',
      addGroup: 'group/addGroup',
      changeGroupName: 'group/changeGroupName',
      leaveGroup: 'group/leaveGroup',
      addMemberToGroup: 'group/addMemberToGroup',
      deleteMemberFromGroup: 'group/deleteMemberFromGroup',
      getMembersOfGroup: 'group/getMembersOfGroup',
      getMyGroupList: 'group/getMyGroupList',
      getRecentVisitGroup: 'group/getRecentVisitGroup',
    },
    Site: {
      getRecentViewSiteList: 'site/getRecentViewSiteList',
      getLikeSiteList: 'site/getLikeSiteList',
      setLikeSite: 'site/setLikeSite',
      setCompleteSite: 'site/setCompleteSite',
      reportSite: 'site/reportSite',
      reportHo: 'site/reportHo_app',
      setCompleteHouse: 'site/setCompleteHouse',
      getSiteDetail: 'site/getSiteDetail',
      addSiteMemo: 'site/addSiteMemo',
      // searchSiteForMap: 'site/searchSiteForMap',
      searchSiteForMap_app: 'site/searchSiteForMapV2_app',
      searchSiteForMap: 'site/searchSiteForMapV2',
      // searchSiteList: 'site/searchSiteList',
      searchSiteList: 'site/searchSiteListV2',
      searchSiteListByPos: 'site/searchSiteListByPos',
      addSite: 'site/addSite',
      addSite_app: 'site/addSite_app',
      updateSite: 'site/updateSite',
      updateSite_app: 'site/updateSite_app',
      transferSite: 'site/transferSite',
      expandGeneralSiteExpireDays: 'site/expandGeneralSiteExpireDays',
      removeSite: 'site/removeSite',
      removeSiteForever: 'site/removeSiteForever',
      restoreAndHiddenSite: 'site/restoreAndHiddenSite',
      getMySiteList: 'site/getMySiteList',
      getSiteForReport: 'site/getSiteForReport',
      getSiteForReportResult: 'site/getSiteForReportResult',
      getInterestSiteList: 'site/getInterestSiteList',
      getMyOpenSaleList: 'site/getMyOpenSaleList',
      getAreaList: 'site/getAreaList',
      setAreaLike: 'site/setAreaLike',
      setHideSite: 'site/setHideSite',
      findSiteListByPhone: 'site/findSiteListByPhone',
      findSiteListByName: 'site/findSiteListByName',
      checkTemporarySave: 'site/checkTemporarySave',
      removeTemporarySave: 'site/removeTemporarySave',
      setTotalAreaLike: 'site/setTotalAreaLike',
      getSiteOfGroup: 'site/getSiteOfGroup',
      updateGeneralSite: 'site/updateGeneralSite',
      findSiteByStatus: 'site/findSiteByStatus',
      findAddress: 'site/findAddress',
    },
    Notify: {
      getTodayNotifyList: 'notify/getTodayNotifyList',
      getMyNotifyList: 'notify/getMyNotifyList',
      getSiteNotifyList: 'notify/getSiteNotifyList',
      getTodayWritingCount: 'notify/getTodayWritingCount',
      addNotify: 'notify/addNotify',
      updateNotify: 'notify/updateNotify',
      updateAutoNotify: 'notify/updateAutoNotify',
      removeNotify: 'notify/removeNotify',
      setRead: 'notify/setRead',
      findNotifyList: 'notify/findNotifyList',
      getNotifyList: 'notify/getNotifyList',
      getNotifyList1: 'notify/getNotifyList1',
      getMyAutoNotify: 'notify/getMyAutoNotify',
      getNotifyDetail: 'notify/getNotifyDetail',
      getRecentNotifyDetailBySite: 'notify/getRecentNotifyDetailBySite',
    },
    Community: {
      getCommunityDetail: 'community/getCommunityDetail',
      getCommunityList: 'community/getCommunityList',
      getTodayWritingCount: 'community/getTodayWritingCount',
      addCommunity: 'community/addCommunity',
      updateCommunity: 'community/updateCommunity',
      removeCommunity: 'community/removeCommunity',
      findCommunityList: 'community/findCommunityList',
      addCommunityComment: 'community/addCommunityComment',
      updateCommunityComment: 'community/updateCommunityComment',
      removeCommunityComment: 'community/removeCommunityComment',
      reportOrPreventCommunity: 'community/reportPreventCommunity',
    },
    Inquire: {
      getInquireList: 'inquire/getInquireList',
      addInquire: 'inquire/addInquire',
      updateInquire: 'inquire/updateInquire',
      removeInquire: 'inquire/removeInquire',
      sendInquireAnswer: 'inquire/sendInquireAnswer',
    },
    Purchase: {
      buyPoint: 'purchase/buyPoint',
      addPoint: 'purchase/addPoint',
      addPeriod: 'purchase/addPeriod',
      getPointLog: 'purchase/getPointLog',
      buyPeriod: 'purchase/buyPeriod'
    },
    Admin: {
      findUserListByPhone: 'admin/findUserListByPhone',
      updateAppInfo: 'admin/updateAppInfo',
      getHomeSetting: 'admin/getHomeSetting',
      updateHomeSetting: 'admin/updateHomeSetting',
      updateAdsImage: 'admin/updateAdsImage',
      updateAdsPeriod: 'admin/updateAdsPeriod',
      updateAdsConnect: 'admin/updateAdsConnect',
      getSaleReqUserList: 'admin/getSaleReqUserList',
      getCompleteReqSite: 'admin/getCompleteReqSite',
      updateAdminAuthority: 'admin/updateAdminAuthority',
      getCompleteReqSiteOld: 'admin/getCompleteReqSiteOld',
      downloadUserTable: 'admin/downloadUserTable',
      blockPhone: 'admin/blockPhone',
      unblockPhone: 'admin/unblockPhone',
      payOrRejectForReport: 'admin/payOrRejectForReport',
    },
    INQUIRY: {
      getBrTitleInfo: 'https://apis.data.go.kr/1613000/BldRgstHubService/getBrTitleInfo',
      getBrFlrOulnInfo: 'https://apis.data.go.kr/1613000/BldRgstHubService/getBrFlrOulnInfo',
      getBrExposInfo: 'https://apis.data.go.kr/1613000/BldRgstHubService/getBrExposPubuseAreaInfo',
      getLandPrice: 'site/getLandPrice',
      getApartPrice: 'site/getApartPrice',
      getApartPrice2: 'site/getApartPrice2',
      getIndvdPrice: 'site/getIndvdPrice',
      getOfficetel: 'site/getOfficetel',
      getOfficetel2: 'site/getOfficetel2',
      getOfficetel3: 'site/getOfficetel3',
      getOfficetel4: 'site/getOfficetel4',
      getOfficetelPrice: 'site/getOfficetelPrice',
      getActualTransaction: 'site/getActualTransaction'
    }
  },

  install: function(Vue, options) {
    Vue.prototype.$c = this;
  },
}

export default Constant;



// WEBPACK FOOTER //
// ./src/config/constant.js